/**
 * Sanitize a UTM parameter value:
 * 1. lowercase
 * 2. strip leading @ (for handles)
 * 3. spaces → underscores
 * 4. remove everything except a-z 0-9 _
 * 5. collapse consecutive underscores
 * 6. trim leading/trailing underscores
 */
export function sanitizeUtmValue(raw: string): string {
  return raw
    .toLowerCase()
    .replace(/^@/, '')
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_]/g, '')
    .replace(/_{2,}/g, '_')
    .replace(/^_|_$/g, '');
}

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'] as const;

/**
 * Build the final URL by merging UTM params into the base URL.
 * If the base URL already contains any UTM keys we care about, overwrite them.
 * Existing non-UTM query params are preserved.
 */
export function buildTrackingUrl(
  baseUrl: string,
  utmSource: string,
  utmMedium: string,
  utmCampaign: string,
  utmContent: string,
): string {
  try {
    const url = new URL(baseUrl);

    UTM_KEYS.forEach((key) => url.searchParams.delete(key));

    url.searchParams.set('utm_source', utmSource);
    url.searchParams.set('utm_medium', utmMedium);
    url.searchParams.set('utm_campaign', utmCampaign);
    url.searchParams.set('utm_content', utmContent);

    return url.toString();
  } catch {
    return '';
  }
}
